// Backend API configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000';

// External API endpoints (kept for direct access if needed)
export const API_BASE = "https://clinicaltrials.gov/api/v2";

// Backend API endpoints
export const API_ENDPOINTS = {
  // AI endpoints
  AI_GROQ: `${BACKEND_URL}/api/ai/groq`,
  AI_TOGETHER: `${BACKEND_URL}/api/ai/together`,
  AI_GEMINI: `${BACKEND_URL}/api/ai/gemini`,
  
  // Geo endpoints
  GEO_GEOCODE: `${BACKEND_URL}/api/geo/geocode`,
  GEO_ZIPCODE: `${BACKEND_URL}/api/geo/zipcode`,
  GEO_REVERSE: `${BACKEND_URL}/api/geo/reverse`,
  
  // Trials endpoints
  TRIALS_SEARCH: `${BACKEND_URL}/api/trials/search`,
  TRIALS_DETAIL: `${BACKEND_URL}/api/trials`,
  
  // Health check
  HEALTH: `${BACKEND_URL}/api/health`
};
